//initial redux
import { put, call, takeEvery, fork, all, takeLatest } from 'redux-saga/effects'
import securityservice from '../../services/security/security';
import { actions as loginactions } from '../Login/redux';

const initialState = {
    userName: null,
    isBusy: false,
    errors: [],
    hasError: false,
};


/////////
//types
export const types = {
    CREATE: "screens/signup/CREATE",
    ON_CREATE: "screens/signup/ON_CREATE",
    ON_CREATE_FAILED: "screens/signup/ON_CREATE_FAILED",
}


///////////
//reducers
export const reducers = {
    reducer(state = initialState, action) {
        switch (action.type) {

            case types.CREATE:
                return { ...state, isBusy: true, hasError: false };
            case types.ON_CREATE:
                return { ...state, isBusy: false, userName: action.payload.username };
            case types.ON_CREATE_FAILED:
                return { ...state, errors: state.errors.concat(action.payload), hasError: true, isBusy: false };

            default:
                return state;
        }
    },
}

//////////
//sagas
export const sagas = {
    *rootSaga() {
        yield all([
            this.onCreate(),
        ]);
    },

    *onCreate() {
        yield takeLatest(types.CREATE, function* ({ payload }) {
            payload.user.phoneNumber = payload.user.phoneNumber || "";
            const rtn = yield call(securityservice.createUser, payload.user);
            if (rtn instanceof Error) {
                console.log("er", rtn);
                const reason = JSON.parse(JSON.parse(rtn.message)._bodyText);
                if (reason.modelState != undefined) {
                    yield put(actions.genericAction(types.ON_CREATE_FAILED, reason.modelState[""][0]));
                } else {
                    yield put(actions.genericAction(types.ON_CREATE_FAILED, reason.message));
                }
            } else {
                yield put(actions.onCreate(payload.user.username));
                yield put(loginactions.changeScreen('login'));
            }
        });
    },

}


////////
//actions
export const actions = {

    create(user) {
        return {
            type: types.CREATE,
            payload: {
                user
            }
        };
    },

    onCreate(username) {
        return {
            type: types.ON_CREATE,
            payload: {
                username
            }
        };
    },

    genericAction(type, data) {
        return {
            type,
            payload: data
        };
    },

}









// WEBPACK FOOTER //
// ./src/ui/SignUp/redux.js